import { NgModule } from '@angular/core';
import { AtomsModule } from '@library/ui/atoms/atoms.module';
import { IconTitleComponent } from './icon-title.component';

@NgModule({
  declarations: [
    IconTitleComponent
  ],
  exports: [
    IconTitleComponent
  ],
  imports: [
    AtomsModule
  ]
})
export class IconTitleModule { }
